import { render, staticRenderFns } from "./company-edit-widget.vue?vue&type=template&id=1add75f1&scoped=true&"
import script from "./company-edit-widget.vue?vue&type=script&lang=js&"
export * from "./company-edit-widget.vue?vue&type=script&lang=js&"
import style0 from "./company-edit-widget.vue?vue&type=style&index=0&id=1add75f1&scoped=true&lang=css&"
import style1 from "./company-edit-widget.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add75f1",
  null
  
)

export default component.exports